<!-- The middle column. Exactly four appearances and no fifth:
       idle (nothing yet) · running (empty — the chassis shades the whole panel with the spinner) ·
       revealed (the cards) · the one sentence.

     One reveal: while the run works nothing is here, and when the delivery lands every card
     appears together, already in the run's order. No card is shown before its rank exists. -->

<div class="mv-results" data-element="maven-results">

  <!-- The trader's sort. The ONLY thing that re-orders this column.

       THE ORION STRIPE (owner, vrequest 2026-09-13): "the sorting panel should look like it looks
       in the other ORIONs — just a stripe, and it says Sort by and then provides the attribute".
       Two keys, and no third: cost per day and total.

       PINNED ABOVE THE SCROLL VIEW, NOT INSIDE IT (owner, second pass the same day): it must not
       scroll away with the cards; it spans the full column width (the scrollbar may overlap it),
       and its content is CENTRED — that replaces the first pass's right alignment.

       ⚠ The <i> is rendered UNCONDITIONALLY and carries its glyph through [ngClass] — a null class
       paints nothing while the element still holds its width, so the row does not jog sideways
       when the caret moves to the other key. An *ngIf here would undo that. -->
  <div class="results-toolbar" *ngIf="!this.running && this.hasCards" data-element="results-sortbar">
    <span class="sort-label">Sort by:</span>

    <span class="sort-key"
          [class.active]="this.sortKey === 'perDay'"
          title="Order by cost per day"
          data-element="sort-per-day"
          (click)="this.onSort('perDay')">Cost per day<i class="arrow"
            [ngClass]="this.sortArrowClass('perDay')"></i></span>

    <span class="sort-key"
          [class.active]="this.sortKey === 'total'"
          title="Order by total cost"
          data-element="sort-total"
          (click)="this.onSort('total')">Total<i class="arrow"
            [ngClass]="this.sortArrowClass('total')"></i></span>
  </div>

  <!-- DevExtreme's scroll view, NOT native overflow (owner ruling, 2026-09-11): nothing in this
       application scrolls natively, and the bare tag is the house form — the sizing is on the
       parent, .mv-scroll-body. -->
  <div class="mv-scroll-body">
  <dx-scroll-view>

  <!-- The scroll view's scrollbar is an OVERLAY drawn over the content's right edge; this wrapper
       carries the right padding that keeps the cards out from under it (vrequest 2026-09-13,
       Results item 1) — the same fix the Setup column got in the commit before. -->
  <div class="results-scroll-content">

  <ng-container *ngIf="!this.running">

    <!-- CR-20260914-001 — the scoped exception to R-C. The dates on which a side could not be
         hedged to the expected range, one line each, as the backend worded them. Above the cards
         (some days survived) or under the sentence (none did). This is the ONE dropped-day reason
         this column shows; nothing else about a dropped day is rendered. -->
    <div class="range-notes" *ngIf="this.expectedRangeNotes.length > 0 && this.hasCards"
         data-element="results-range-notes">
      <div class="range-note" *ngFor="let line of this.expectedRangeNotes">{{ line }}</div>
    </div>

    <div class="cardlist" *ngIf="this.hasCards" data-element="results-cardlist">
      <ets-maven-card *ngFor="let card of this.visibleCards; trackBy: this.trackCard"
                      [card]="card"
                      [live]="this.liveFor(card)"
                      [existingHedges]="this.delivery?.existingHedges"
                      [score]="this.scoreFor(card)"
                      [selected]="this.isSelected(card)"
                      (picked)="this.onCardPicked($event)">
      </ets-maven-card>
    </div>

    <!-- The backend's sentence. The only message this column shows, and only when a run produced
         no packages at all — a blank column reads as a failure. -->
    <div class="empty" *ngIf="this.emptySentence" data-element="results-empty">{{ this.emptySentence }}</div>

    <div class="range-notes" *ngIf="this.expectedRangeNotes.length > 0 && !this.hasCards"
         data-element="results-range-notes">
      <div class="range-note" *ngFor="let line of this.expectedRangeNotes">{{ line }}</div>
    </div>

  </ng-container>

  </div><!-- /.results-scroll-content -->
  </dx-scroll-view>
  </div><!-- /.mv-scroll-body -->

</div>
